<template>
  <div class="about">
    <img class="fotoa" src="foto_Architetti.jpg"/>
    <!-- {{lang}} -->
    
    <about-it v-if="lang=='it'"></about-it>
    <about-en v-if="lang=='en'"></about-en>
  
    
  </div>
</template>

<script>
  import AboutIt from "@/views/AboutIt.vue";
  import AboutEn from "@/views/AboutEn.vue";

  export default {
    props: ['lang'],
    components: {
      AboutIt,
      AboutEn
    },
    beforeCreate: function() {
        document.body.className = 'bodyabout';
    }
  }
</script>

<style>
  .about {
    padding-bottom: 80px;
  }

  .bodyabout .bg {
    background-image: none;
    background-color: white;
  }

  .bodyabout  .bfafooter {
    background-color: rgba(0,0,0,0.9);
  }


  .fotoa {
    width: 100%;
  }

  .testo {
    font-size: small;
  }

  .titolo {
    background-color: black;
    color: white;
    padding: 0.5rem;
    font-size: 0.8rem;
  }
</style>
